import { useChatContext } from './ChatContext';

const useMessageContainerRef = () => {
    const { messageContainerRef } = useChatContext();
    return messageContainerRef;
};

export default useMessageContainerRef;
